import React, { Component } from "react";
import { Navigate } from 'react-router-dom';
import { TableRow, TableCell } from "../../ui/table";
import { Button } from "../../ui/button";
import { Badge } from "../../ui/badge";
import { ExternalLink, UserRoundX } from "lucide-react";

class Users_no_row extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
        };
        this.redirect_to_user = this.redirect_to_user.bind(this);
    }

    redirect_to_user(userName, event) {
        event.preventDefault();
        this.setState({ username: userName });
    }

    getStatusBadge(requestStatus, domainStatus) {
        if (requestStatus === "Approved" && domainStatus === true) {
            return <Badge className="bg-green-100 text-green-800 hover:bg-green-100">Approved</Badge>;
        }
        if (requestStatus === "Submitted" && domainStatus === true) {
            return <Badge className="bg-green-100 text-green-800 hover:bg-green-100">Active</Badge>;
        }
        if (requestStatus === "Submitted" && domainStatus === false) {
            return <Badge className="bg-gray-100 text-gray-800 hover:bg-gray-100">Inactive</Badge>;
        }
        if (requestStatus === "Pending") {
            return <Badge className="bg-yellow-100 text-yellow-800 hover:bg-yellow-100">Pending</Badge>;
        }
        if (requestStatus === "Rejected") {
            return <Badge className="bg-red-100 text-red-800 hover:bg-red-100">Rejected</Badge>;
        }
        return null;
    }

    render() {
        if (this.state.username !== '') {
            return <Navigate replace to={{ pathname: "/Admin/users", state: { property_id: this.state.username } }} />;
        }

        const { fullName, groupNumber, requestId, requestStatus, subDomain, userId, domainStatus, userName } = this.props;

        if (!fullName) {
            return (
                <TableRow>
                    <TableCell colSpan={5} className="text-center py-8 text-gray-500">
                        No Record Found
                    </TableCell>
                </TableRow>
            );
        }

        return (
            <TableRow className="hover:bg-gray-50">
                <TableCell>
                    <button
                        onClick={(e) => this.redirect_to_user(userName, e)}
                        className="text-brand-dark hover:text-brand-accent font-medium transition-colors"
                    >
                        {fullName}
                    </button>
                </TableCell>
                <TableCell className="text-brand-dark">{groupNumber}</TableCell>
                <TableCell>
                    <a
                        href={subDomain}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-brand-dark hover:text-brand-accent inline-flex items-center gap-1 transition-colors"
                    >
                        {subDomain}
                        <ExternalLink className="h-3 w-3" />
                    </a>
                </TableCell>
                <TableCell>
                    {this.getStatusBadge(requestStatus, domainStatus)}
                </TableCell>
                <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-2">
                        {requestStatus === "Pending" && domainStatus === true && (
                            <>
                                <Button
                                    size="sm"
                                    onClick={() => this.props.pricing_action(userId, requestId, "Accept")}
                                    className="bg-green-600 hover:bg-green-700 text-white"
                                >
                                    Accept
                                </Button>
                                <Button
                                    size="sm"
                                    variant="destructive"
                                    onClick={() => this.props.pricing_action(userId, requestId, "Reject")}
                                >
                                    Reject
                                </Button>
                            </>
                        )}
                        {requestStatus === "Submitted" && domainStatus === true && (
                            <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => this.props.activate_deactivate_action(userId, requestId, "Deactivate")}
                                className="h-8 w-8 p-0"
                            >
                                <UserRoundX className="h-4 w-4 text-red-600" />
                            </Button>
                        )}
                        {requestStatus === "Submitted" && domainStatus === false && (
                            <Button
                                size="sm"
                                variant="secondary"
                                onClick={() => this.props.activate_deactivate_action(userId, requestId, "Activate")}
                            >
                                Activate Tool
                            </Button>
                        )}
                    </div>
                </TableCell>
            </TableRow>
        );
    }
}

export default Users_no_row;
